import { FormikErrors } from 'formik';
import {
  createContext,
  ReactNode,
  useContext,
  useMemo,
  useState,
} from 'react';

export interface ITabsNavigationItem {
  name: string;
  value: number;
  error?:
    | string
    | (string | undefined)[]
    | FormikErrors<any>[]
    | FormikErrors<any>;
  helper?: string;
  warning?: boolean | string | (string | undefined)[];
  permissionName?: string;
  permissionNames?: string[];
}

interface ITabsNavigationContextValue {
  tabs: ITabsNavigationItem[];
  setTabs: (tabs: ITabsNavigationItem[]) => void;
  displayMode?: boolean;
  setDisplayMode: (displayMode: boolean) => void;
}

const TabsNavigationContext = createContext<ITabsNavigationContextValue | null>(
  null,
);

export const TabsNavigationProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [tabs, setTabs] = useState<ITabsNavigationItem[]>([]);
  const [displayMode, setDisplayMode] = useState(false);

  const value = useMemo(
    () => ({
      tabs,
      setTabs,
      displayMode,
      setDisplayMode,
    }),
    [tabs, displayMode],
  );

  return (
    <TabsNavigationContext.Provider value={value}>
      {children}
    </TabsNavigationContext.Provider>
  );
};

export const useTabsNavigationContext = () =>
  useContext(TabsNavigationContext);
